export default __webpack_public_path__ + "static/media/greyMessage.a800e26a.svg";